var map = {
	"./1__Felicitas Ernst_Visa_fotografía_gato_2.webp": "./src/img/brands/VISA/1__Felicitas Ernst_Visa_fotografía_gato_2.webp",
	"./2_Felicitas Ernst_Visa_fotografía_gato.webp": "./src/img/brands/VISA/2_Felicitas Ernst_Visa_fotografía_gato.webp",
	"./3_Felicitas ernst, visa, gato. MG_0355.webp": "./src/img/brands/VISA/3_Felicitas ernst, visa, gato. MG_0355.webp",
	"./MG_0196_ copia.webp": "./src/img/brands/VISA/MG_0196_ copia.webp",
	"./MG_0409_ copia 3.webp": "./src/img/brands/VISA/MG_0409_ copia 3.webp",
	"./MG_0447__ copy.webp": "./src/img/brands/VISA/MG_0447__ copy.webp",
	"./MG_0519 copy.webp": "./src/img/brands/VISA/MG_0519 copy.webp",
	"./Mailing-Intercam-VISA_CATAR.webp": "./src/img/brands/VISA/Mailing-Intercam-VISA_CATAR.webp",
	"./football-players-1600x900.webp": "./src/img/brands/VISA/football-players-1600x900.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/VISA sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";